import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const BulkActions = ({ selectedCount, onAction }) => {
  const staffOptions = [
    { value: 'staff1', label: 'Marie Dubois' },
    { value: 'staff2', label: 'Jean Martin' },
    { value: 'staff3', label: 'Sophie Laurent' },
    { value: 'staff4', label: 'Pierre Bernard' }
  ];

  if (selectedCount === 0) return null;

  return (
    <div className="bg-primary/10 border border-primary/20 rounded-lg p-4 mb-6">
      <div className="flex flex-col lg:flex-row items-start lg:items-center gap-4">
        <div className="flex items-center gap-2">
          <Icon name="CheckSquare" size={20} className="text-primary" />
          <span className="text-sm font-semibold text-foreground">
            {selectedCount} cas sélectionné{selectedCount > 1 ? 's' : ''}
          </span>
        </div>

        <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 flex-1">
          <div className="w-full sm:w-48">
            <Select
              placeholder="Réassigner le personnel"
              options={staffOptions}
              value=""
              onChange={(value) => onAction('reassignStaff', value)}
            />
          </div>

          <Button
            variant="outline"
            size="sm"
            iconName="Download"
            iconPosition="left"
            onClick={() => onAction('export')}
          >
            Exporter
          </Button>

          <Button
            variant="ghost"
            size="sm"
            iconName="X"
            onClick={() => onAction('clearSelection')}
          >
            Désélectionner
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BulkActions;